document.addEventListener("DOMContentLoaded", function () {
    const slider = new Swiper('.eggo-home-slider', {
        loop: true,
        pagination: {
            el: '.eggo-home-slider__bullets',
            type: 'bullets',
            clickable: true
        }
    });
    bullets();
});

const bullets = () => {
    const imageElement = document.querySelector(".eggo-home-slider__slide-image");
    const bulletElement = document.querySelector(".eggo-home-slider__bullets");
    if (!imageElement || !bulletElement) return;
    setBulletsPosition(imageElement, bulletElement);
    window.addEventListener("resize", () => {
        setBulletsPosition(imageElement, bulletElement);
    });
}

const setBulletsPosition = (imageElement, bulletElement) => {
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
    if (vw < 768) {
        const width = imageElement.clientWidth;
        bulletElement.style.top = (width - 12) + "px";
    }
    else{
        bulletElement.style.top = null;
    }
}
